// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AddOrUpdateSubscriptionsData, AddOrUpdateSubscriptionsErrors, AddOrUpdateSubscriptionsResponses, GetCustomerAccessPointsData, GetCustomerAccessPointsErrors, GetCustomerAccessPointsResponses, GetMeterReadingsData, GetMeterReadingsErrors, GetMeterReadingsResponses, GetOptionsData, GetOptionsErrors, GetOptionsResponses, GetSubscriptionsByIdData, GetSubscriptionsByIdErrors, GetSubscriptionsByIdResponses, PostMessageData, PostMessageErrors, PostMessageResponses, RegisterMeterReadingData, RegisterMeterReadingErrors, RegisterMeterReadingResponses, RemoveAllSubscriptionsData, RemoveAllSubscriptionsErrors, RemoveAllSubscriptionsResponses, RemoveSubscriptionsData, RemoveSubscriptionsErrors, RemoveSubscriptionsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get access log events for a given customer id.
 * Returns the results in descending order of accessDate.
 */
export const getCustomerAccessPoints = <ThrowOnError extends boolean = false>(options: Options<GetCustomerAccessPointsData, ThrowOnError>) => (options.client ?? client).get<GetCustomerAccessPointsResponses, GetCustomerAccessPointsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/AccessLog/customers/{customerId}/events',
    ...options
});

export const getMeterReadings = <ThrowOnError extends boolean = false>(options: Options<GetMeterReadingsData, ThrowOnError>) => (options.client ?? client).get<GetMeterReadingsResponses, GetMeterReadingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/customer/{customerNumber}/installations/{installationId}/meterreadings/{meterpointId}',
    ...options
});

/**
 * Registers new meter reading
 */
export const registerMeterReading = <ThrowOnError extends boolean = false>(options: Options<RegisterMeterReadingData, ThrowOnError>) => (options.client ?? client).post<RegisterMeterReadingResponses, RegisterMeterReadingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/customer/{customerNumber}/installations/{installationId}/meterreadings/{meterpointId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all subscriptions that belonging to a customer account.
 */
export const getSubscriptionsById = <ThrowOnError extends boolean = false>(options?: Options<GetSubscriptionsByIdData, ThrowOnError>) => (options?.client ?? client).get<GetSubscriptionsByIdResponses, GetSubscriptionsByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/interruption/subscriptions',
    ...options
});

/**
 * Add or update user accounts that will be linked to current customer (identification number).
 */
export const addOrUpdateSubscriptions = <ThrowOnError extends boolean = false>(options?: Options<AddOrUpdateSubscriptionsData, ThrowOnError>) => (options?.client ?? client).post<AddOrUpdateSubscriptionsResponses, AddOrUpdateSubscriptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/interruption/subscriptions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete all subscriptions with the specified subscription IDs
 */
export const removeSubscriptions = <ThrowOnError extends boolean = false>(options: Options<RemoveSubscriptionsData, ThrowOnError>) => (options.client ?? client).delete<RemoveSubscriptionsResponses, RemoveSubscriptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/interruption/subscriptions/{customerNumber}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove all subscriptions assigned to the given customer number.
 */
export const removeAllSubscriptions = <ThrowOnError extends boolean = false>(options: Options<RemoveAllSubscriptionsData, ThrowOnError>) => (options.client ?? client).delete<RemoveAllSubscriptionsResponses, RemoveAllSubscriptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/interruption/subscriptions/{customerNumber}/all',
    ...options
});

/**
 * Används idag för
 * FlexAccountRequest,
 * FlexAccountPaymentRequest,
 * WaterAndDrainManualReadingFallback,
 * OperationAgreementHeatingExchanger,
 * PowerHubRequest,
 * ServiceAgreementHeatingExchanger
 */
export const postMessage = <ThrowOnError extends boolean = false>(options?: Options<PostMessageData, ThrowOnError>) => (options?.client ?? client).post<PostMessageResponses, PostMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get all available options for a given message type.
 */
export const getOptions = <ThrowOnError extends boolean = false>(options?: Options<GetOptionsData, ThrowOnError>) => (options?.client ?? client).get<GetOptionsResponses, GetOptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/messages/options',
    ...options
});
